import React from 'react';

type Props = {
  billedSeats: number | null;
  activeUsers: number;
};

export const VacantSeats = ({ billedSeats, activeUsers }: Props) => {
  const vacantSeats = billedSeats != null ? Math.max(0, billedSeats - activeUsers) : null;

  if (vacantSeats == null || vacantSeats <= 0) {
    return null;
  }

  return (
    <div className="subscription-detail-row flex aic jcsb py-2">
      <div>
        <div className="f-1 blueGray mb-1">Vacant seats this period</div>
        <div className="f-16 bold">{vacantSeats}</div>
      </div>
    </div>
  );
};
